import React from 'react'
import { IConfirmationCard } from '../../interface'
import { useTranslation } from 'react-i18next'
import './ConfirmationCard.scss'

export const ConfirmationCard = ({ description, info, title, tRoot }: IConfirmationCard): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div className='confirmation-card'>
      <h6 className='confirmation-card__title'>{title}</h6>
      <div className='confirmation-card__content'>
        <p className='confirmation-card__content-description'>{description}</p>
        <div className='confirmation-card__content-grid'>
          {Object.keys(info).map((key, index) => {
            const key_label = `info-card-${key}${index}`
            const title_label = t(`${tRoot}.${key}`)

            return (
              <div key={key_label} className='confirmation-card__item'>
                <p className='confirmation-card__item-title'>{title_label}</p>
                <p className='confirmation-card__item-value'>{info[key]}</p>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
